import axios from 'axios'
import moment from 'moment'
import { getJWT, getLocal } from '../Utils/Profile'
import { BASEAPI } from './constants'

export async function getDataInvoice() {
    const now = moment().format('YYYY-MM-DD')
    const last = moment().subtract(1, 'months').format('YYYY-MM-DD')
    const API_COMMERCE = 'amipos-back/sales/movements/ecommerce/store'

    const url = `${BASEAPI}${API_COMMERCE}/${getLocal()}`
    return axios.get(url, { headers: { Authorization: getJWT() } })
}

export async function getHomeGuides() {
    return axios.get(`${BASEAPI}amipos-back/guides`, {
        headers: { Authorization: getJWT() },
    })
}
export async function getPlanPrice() {
    try {
        const response = await axios.get(
            'https://servicesamiposweb.amipass.com/amipos/amipos-back/upselling/prices/all',
            {
                headers: { Authorization: getJWT() },
            }
        )
        return response
    } catch (error) {
        console.error('Error en getPlanPrice:', error)
        throw error
    }
}

export async function payPlan(data: any) {
    return axios.post(`${BASEAPI}upselling/initPayment`, data, {
        headers: { Authorization: getJWT() },
    })
}

export async function getHomeDataGraphics() {
    return axios.get(
        `${BASEAPI}amipos-back/graphics/data/ecommerce/store/${getLocal()}`,
        {
            headers: { Authorization: getJWT() },
        }
    )
}

export async function getHomeMissions() {
    return axios.get(
        `${BASEAPI}amipos-back/missions/ecommerce/store/${getLocal()}`,
        {
            headers: { Authorization: getJWT() },
        }
    )
}

export async function getHomeTools() {
    return axios.get(`${BASEAPI}amipos-back/tools`, {
        headers: { Authorization: getJWT() },
    })
}

export async function getHomeTransactions() {
    const local = getLocal()
    const now = moment().format('YYYY-MM-DD')
    const last = moment().subtract(1, 'months').format('YYYY-MM-DD')
    const API_COMMERCE = 'amipos-back/sales/movements/ecommerce/store'
    const url = `${BASEAPI}${API_COMMERCE}/${local}/${last}/10000/${now}`

    return axios.get(url, { headers: { Authorization: getJWT() } })
}

export async function getFilterProducts(name: string) {
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()

    return axios.get(`${BASEAPI}amipos-back/products/store/${getLocal()}`, {
        headers: { Authorization: getJWT() },
        params: {
            page: 1,
            limit: 10,
            productName: name,
            hasPrmotions: false,
            isSettlement: false,
            commerce: internalID,
        },
    })
}
